import cx from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslations } from 'next-intl'

import FreeBonus from '@/assets/images/storefronts/brawlstars/brawl-gems.svg'

import { useGameSlug } from '../../../game-provider'
import { DrawerButton } from '../../bonusStatusFooter/DrawerButton'
import { Flare } from '../../flare/Flare'
import { StoreTypography } from '../../typography/StoreTypography'

import styles from './logInBonusFooter.module.scss'

export const LogInBonusFooter = () => {
  const gameSlug = useGameSlug()
  const { asPath, query } = useRouter()
  query.redirectUri = asPath
  const pathname = `/oauth/begin`
  const isBrawl = gameSlug === 'brawlstars'

  const t = useTranslations()
  const brawlLoginTextArr = t('login_free_gems').split(/(?=10)/)

  return (
    <Link className={cx(styles.logInBonusFooter, styles[gameSlug])} href={{ pathname, query }}>
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <div className={styles.textWrapper}>
            {isBrawl ? (
              <>
                <StoreTypography
                  className={styles.subtitle}
                  tag="h4"
                  textSize="sm"
                  overrideFont="supercellText"
                  style="plain"
                >
                  {brawlLoginTextArr[0]}
                </StoreTypography>

                <StoreTypography
                  className={styles.title}
                  tag="h3"
                  textSize="md"
                  overrideFont="supercellHeadline"
                  style="plain"
                  lineHeight="normal"
                >
                  {brawlLoginTextArr[1]}
                </StoreTypography>
              </>
            ) : (
              <StoreTypography
                className={styles.title}
                tag="h3"
                textSize="md"
                overrideFont="supercellHeadline"
                style="plain"
                lineHeight="normal"
              >
                {t('login_free_bonus')}
              </StoreTypography>
            )}
          </div>

          <div className={styles.buttonWrapper}>
            <DrawerButton />
          </div>
        </div>

        {isBrawl && (
          <div className={styles.bonusFooterImage}>
            <div className={styles.flareContainer}>
              <Flare />
            </div>

            <div className={styles.bonusImageContainer}>
              <Image src={FreeBonus} alt="reward-image" height={100} width={100} quality={100} priority />
            </div>
          </div>
        )}
      </div>
    </Link>
  )
}
